module.exports = __webpack_public_path__ + "img/cheapcarsforsale.5d2a9831.png";